module.exports = __webpack_public_path__ + "img/REPL .02420908.svg";